import unlimitedOption from '../constants/unlimitedOption';

const getHideValue = (
givenHideValue,
value,
allowUnlimitedOption) =>
allowUnlimitedOption && value === unlimitedOption.value || givenHideValue;

export default getHideValue;